module.exports = __webpack_public_path__ + "img/zeroFive.7c5e430d.png";